import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { HotelRoomPaymentScheduleModal } from "./component";
import { getSelectedAccount } from "../../../rewards/reducer";
import { selectRoomType } from "../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  selectedAccount: getSelectedAccount(state),
});

export const mapDispatchToProps = {
  selectRoomType,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelRoomPaymentScheduleModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedHotelRoomPaymentScheduleModal = connector(
  HotelRoomPaymentScheduleModal
);
